import { API_BASE_URL, requestJson } from './http';

const request = (path, options = {}) =>
  requestJson(`${API_BASE_URL}/api/v1${path}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    fallbackMessage: 'Concept clinic request failed',
  });

export const fetchMyClinicRecords = (params = {}) => {
  const query = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v))
  ).toString();
  return request(`/clinic-records/mine${query ? `?${query}` : ''}`);
};

export const createClinicRecord = (data) =>
  request('/clinic-records', { method: 'POST', body: JSON.stringify(data) });
